const addPrefix = (val: string, prefix: string) => `${prefix}${val}`

export default addPrefix
